import { APITags, REQUEST_TYPES } from 'constants/index';
import baseApi from 'services/api';
import {
  ConnectErpRequestType,
  ConnectErpResponseType,
  ErpConfigsRequestType,
  ErpConfigsResponseType,
  ErpMappingPayloadType,
  ErpMappingRequestType,
  ErpMappingResponseType,
  ErpResponseType,
  InitiateErpConnectionRequestType,
  InitiateErpConnectionResponseType,
  SucceededErpResponseType,
} from 'types/integrationApi.types';

const Integration = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getConnectedErpList: builder.query<SucceededErpResponseType, void>({
      query: () => ({
        url: 'erp/succeeded',
      }),
      transformResponse: ({ data }) => data,
      providesTags: [APITags.GET_CONNECTED_ERP_LIST],
    }),
    getPendingErpList: builder.query<ErpResponseType[], void>({
      query: () => ({
        url: 'erp/pending',
      }),
      transformResponse: ({ data }) => data,
      providesTags: [APITags.GET_PENDING_ERP_LIST],
    }),
    initiateErpConnection: builder.mutation<InitiateErpConnectionResponseType, InitiateErpConnectionRequestType>({
      query: (payload) => ({
        url: 'erp/connect/initiate',
        method: REQUEST_TYPES.POST,
        body: payload,
      }),
      transformResponse: ({ data }) => data,
    }),
    connectErp: builder.mutation<ConnectErpResponseType, ConnectErpRequestType>({
      query: (payload) => ({
        url: 'erp/connect',
        method: REQUEST_TYPES.PATCH,
        body: payload,
      }),
      transformResponse: ({ data }) => data,
    }),
    pollErpConnectionStatus: builder.query<ConnectErpResponseType, string>({
      query: (id) => ({
        url: `erp/connect/${id}`,
      }),
      transformResponse: ({ data }) => data,
    }),
    getErpMapping: builder.query<ErpMappingResponseType, ErpMappingRequestType>({
      query: ({ action, erpConnectionId, platform }) => ({
        url: 'erp/map',
        params: {
          action,
          connection_id: erpConnectionId,
          platform,
        },
      }),
      providesTags: [APITags.GET_ERP_MAPPING],
      transformResponse: ({ data }) => data,
    }),
    saveErpMapping: builder.mutation<ErpMappingResponseType, ErpMappingPayloadType>({
      query: (payload) => ({
        url: 'erp/map',
        method: REQUEST_TYPES.POST,
        body: payload,
      }),
      invalidatesTags: (_, error) => {
        if (!error) return [APITags.GET_CONNECTED_ERP_LIST, APITags.GET_PENDING_ERP_LIST, APITags.GET_ERP_MAPPING];

        return [];
      },
      transformResponse: ({ data }) => data,
    }),
    getErpConfigs: builder.query<ErpConfigsResponseType, ErpConfigsRequestType>({
      query: ({ vault_id }) => ({
        url: 'erp/configs',
        params: {
          vault_id,
        },
      }),
      providesTags: [APITags.GET_ERP_MAPPING],
      transformResponse: ({ data }) => data,
    }),
  }),
});

export const {
  useGetConnectedErpListQuery,
  useGetPendingErpListQuery,
  useInitiateErpConnectionMutation,
  useConnectErpMutation,
  useLazyPollErpConnectionStatusQuery,
  useLazyGetErpMappingQuery,
  useSaveErpMappingMutation,
  useGetErpConfigsQuery,
} = Integration;
